import React, { useEffect, useState, useContext } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import Modal from "react-bootstrap/Modal";
import { useUnidades } from "../../../hooks/test/useUnidades";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";

const initialStateFormTienda = {
  cedis_id: "",
  nombre_cedis: "",
  tienda_nombre: "",
  domicilio: "",
  estado: "",
  municipio: "",
  tienda_id: "",
  nombre_encargado: "",
  telefono_encargado: "",
  negocio_id: "",
  latitud: "",
  longitud: "",
};

export const AddTiendas = ({
  show,
  handleClose,
  onTiendaSaved,
  cedis_id,
  idNegocio,
}) => {
  const [form, setForm] = useState(initialStateFormTienda);
  const [loading, setLoading] = useState(false);
  const [entidades, setEntidades] = useState([]);
  const [cedis, setCedis] = useState([]);

  const { postTienda, getEntidadesFederativas, getCedisNegociosAll } =
    useUnidades();

  useEffect(async () => {
    await loadInfo();
  }, []);

  const handleChange = async (event) => {
    let value = event.target.value;
    const name = event.target.name;

    if (name === "telefono_encargado") {
      // Eliminar caracteres no numéricos usando una expresión regular
      value = value.replace(/\D/g, "");

      // Truncar a 10 dígitos si excede
      if (value.length > 10) {
        value = value.substring(0, 10);
      }
    } else if (
      event.target.name !== "estado" &&
      typeof event.target.value === "string"
    ) {
      value = event.target.value.toUpperCase();
    }

    setForm({
      ...form,
      [name]: value,
    });
  };

  const loadInfo = async () => {
    setLoading(true);
    setForm({ ...form, negocio_id: idNegocio, cedis_id: cedis_id });
    let resp = await getEntidadesFederativas();
    if (resp.ok) setEntidades(resp.entidades);
    resp = await getCedisNegociosAll(idNegocio);
    if (resp.ok) setCedis(resp.cedis);

    setLoading(false);
  };

  const resetSaved = async () => {
    setForm({
      ...form,
      nombre_cedis: "",
      tienda_nombre: "",
      domicilio: "",
      estado: "",
      municipio: "",
      tienda_id: "",
      nombre_encargado: "",
      telefono_encargado: "",
      cedis_id: "",
    });
    onTiendaSaved();
  };

  const guardarTienda = async () => {
    setLoading(true);
    const flag = await validaciones();
    if (!flag) {
      console.log("Error al validar los datos de la nueva tienda");
    }
    if (form.tienda_nombre === " ") {
      showToastError("Favor de insertar el nombre de la tienda");
      return;
    }
    if (!form.negocio_id) {
      showToastError("El ID de negocio es requerido.");
      console.log("form:", form);
      return;
    }
    if (!form.cedis_id) {
      showToastError("El ID de CEDIS es requerido.");
      console.log("form:", form);
      return;
    }
    // if (!form.latitud) {
    //   showToastError("El campo latitud es requerido.");
    //   console.log("form:", form);
    //   return;
    // }
    // if (!form.longitud) {
    //   showToastError("El campo longitud es requerido.");
    //   console.log("form:", form);
    //   return;
    // }
    
    let resp = await postTienda(form);
    if (resp.ok) {
      handleClose();
      Swal.fire({
        title: resp.msg,
        icon: "success",
        timer: 3000,
        showConfirmButton: false,
      });

      resetSaved();
    } else {
      if (!flag) {
        console.log("entro al error de cierre del modal");
        Swal.fire({
          title: "Lo siento",
          text: resp.msg,
          icon: "info",
        });
      }
    }
    setLoading(false);
  };

  const validaciones = async () => {
    if (form.tienda_nombre === "") {
      showToastError("Favor de insertar el nombre de la tienda");
      return true;
    }
  };

  const showToastError = (msj = "Ha ocurrido un error") => {
    toast.error(msj, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          handleClose();
          resetSaved();
        }}
        backdrop="static"
        keyboard={true}
        size="xl"
      >
        <form className="form-card">
          <Modal.Header closeButton>
            <Modal.Title>
              {<strong>AGREGUE NUEVA TIENDA</strong>}{" "}
              {loading && <Spinner animation="grow" size="sm" />}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row justify-content-between text-left ">
              <div className="form-group col-sm-6 flex-column d-flex">
                <label>Centro de distribución*</label>
                <select
                  value={cedis_id || form.cedis_id}
                  onChange={handleChange}
                  name="cedis_id"
                  className="form-control"
                  disabled={cedis_id ? true : false}
                >
                  <option value="">Selecciona</option>
                  {cedis.map((x) => {
                    return (
                      <option key={x.cedis_id} value={x.cedis_id}>
                        {x.nombre_cedis}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="form-group col-sm-6 flex-column d-flex">
                {/*Tienda*/}
                <label>Nombre de la Tienda*</label>
                <input
                  name="tienda_nombre"
                  id="tienda_nombre"
                  placeholder="Ingrese nombre de la Tienda"
                  onChange={handleChange}
                  value={form.tienda_nombre}
                  className="form-control"
                />
              </div>
            </div>
            <hr className="mt-3" />
            <div className="mb-3 mt-3 row justify-content-between text-left">
              <div className="form-group col-sm-4 flex-column d-flex">
                <label>Domicilio</label>
                <input
                  name="domicilio"
                  id="domicilio"
                  onChange={handleChange}
                  value={form.domicilio}
                  className="form-control"
                />
              </div>
              <div className="form-group col-sm-4 flex-column d-flex">
                <label>Estado</label>
                <select
                  name="estado"
                  value={form.estado}
                  onChange={handleChange}
                  placeholder=""
                  className="form-control"
                >
                  <option value="">Selecciona Entidad</option>
                  {entidades.map(
                    ({ entidad_federativa_id, entidad_federativa }) => (
                      <option
                        key={entidad_federativa_id}
                        value={entidad_federativa}
                      >
                        {entidad_federativa}
                      </option>
                    )
                  )}
                </select>
              </div>
              <div className="form-group col-sm-4 flex-column d-flex">
                <label>
                  {form.estado
                    ? "Selecciona un Municipio"
                    : "Selecciona una Entidad"}
                </label>
                <input
                  name="municipio"
                  id="municipio"
                  onChange={handleChange}
                  value={form.municipio}
                  className="form-control"
                  disabled={form.estado ? false : true}
                />
              </div>
            </div>
            <div className="row justify-content-between text-left ">
              <div className="form-group col-sm-3 flex-column d-flex">
                <label>Latitud</label>
                <input
                  name="latitud"
                  onChange={handleChange}
                  value={form.latitud}
                  className="form-control"
                />
              </div>
              <div className="form-group col-sm-3 flex-column d-flex">
                <label>Longitud</label>
                <input
                  name="longitud"
                  onChange={handleChange}
                  value={form.longitud}
                  className="form-control"
                />
              </div>
              <div className="form-group col-sm-3 flex-column d-flex">
                <label>Nombre del Encargado</label>
                <input
                  name="nombre_encargado"
                  id="nombre_encargado"
                  onChange={handleChange}
                  value={form.nombre_encargado}
                  className="form-control"
                />
              </div>
              <div className="form-group col-sm-3 flex-column d-flex">
                <label>Teléfono del Encargado</label>
                <input
                  name="telefono_encargado"
                  id="telefono_encargado"
                  onChange={handleChange}
                  value={form.telefono_encargado || ""}
                  className="form-control"
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              disabled={loading ? true : false}
              onClick={async () => guardarTienda()}
              className="btn btn-lg liberarSalida rounded"
              style={{ background: "#0066BF", color: "white" }}
            >
              <FontAwesomeIcon icon={faSave} />
              &nbsp; {loading ? "Creando..." : "Crear Tienda"}
            </button>
            &nbsp;
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};
